const topMain = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let secMain = document.querySelector('#jsSecMain');

    let mainWrap = secMain.querySelector('.js-main-wrap');

    let videoBox = mainWrap.querySelector('.js-video-box');
    let video = videoBox.querySelector('video');
    let fixBox = mainWrap.querySelector('.js-fix-box');
    let skipBox = mainWrap.querySelector('.js-skip-box');


    const fixFunc = () => {
      fixBox.classList.add('act')
      skipBox.classList.add('none')
    }


    // skipボタン押したら
    skipBox.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      fixFunc()
    });


    // 動画おわったら
    video.addEventListener("ended", (e) => {
      setTimeout(() => {
        fixFunc()
      }, 400);
    });



  }
}
export default topMain;